import { FC, memo, useCallback } from 'react'
import styled from 'styled-components';
import { Feedback } from '../../../../../common/store/chat/contants/feedback';
import ThumbDownIcon from '../../../../components/icons/thumb-down';

interface BotChatMessageFeedbackThumbDownIconProps {
  onClick: (feedback: Feedback) => void;
  mode?: Feedback;
}

export const BotChatMessageFeedbackThumbDownIcon: FC<BotChatMessageFeedbackThumbDownIconProps> = memo(({
  onClick,
  mode
}) => {
  const handleClick = useCallback(() => {
    switch (mode) {
      case Feedback.THUM_DOWN: 
        return onClick(Feedback.NULL)
      default:
        return onClick(Feedback.THUM_DOWN)
    }
  }, [onClick, mode]);

  const isActive = mode === Feedback.THUM_DOWN;
  return (
    <Container
      onClick={handleClick}
      className={`voa_chat_bot_message_reaction_button thumbs_down ${isActive ? 'selected' : ''}`}
      isActive={isActive}
    >
      <ThumbDownIcon isActive={isActive} />
    </Container>
  )
});

const Container = styled.button<{ isActive: boolean }>`
  && {
  
    ${(props) => props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.thumbDown?.styles}
    svg {
      path {
        fill: ${(props) => props.isActive ? props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.active?.styles?.fill : props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.outlineColor ? props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.outlineColor : 'black'};
      }
    }
  }
`
